import { createContext } from "react";

export const FlowContext = createContext();
export const FlowContextApi = createContext();
export const CustomNodeContext = createContext();
export const TabContext = createContext();
export const TabContextApi = createContext();
export const ComponentPropsContext = createContext();
export const ComponentPropsContextApi = createContext();
export const FormFieldsContext = createContext();
export const FlowStateContextApi = createContext();
